import React from 'react'
import { Form, TimePicker } from 'antd'
import { Controller } from 'react-hook-form'
import { InfoCircleOutlined } from '@ant-design/icons'

export interface TimeFieldProps {
  fieldname: string
  isRequired?: boolean
  label?: string
  validate?: any
  validMessage?: any
  className?: string
  tooltipTitle?: string
  control: any
  initValue?: any
  rules?: any
  iProps?: any
  prefix?: any
  onTimeChange: any
  hintMessage?: string | React.ReactElement
}

const TimeField: React.FunctionComponent<TimeFieldProps> = ({
  fieldname,
  isRequired,
  label,
  validate,
  validMessage,
  className,
  control,
  initValue,
  rules,
  iProps,
  prefix,
  onTimeChange,
  tooltipTitle,
  hintMessage,
}: TimeFieldProps) => {
  return (
    <Form.Item
      required={isRequired ?? false}
      validateStatus={validate}
      help={validMessage}
      label={label}
      valuePropName="checked"
      className={className}
      tooltip={
        tooltipTitle && {
          title: tooltipTitle,
          icon: <InfoCircleOutlined style={{ color: '#505560', fontSize: '14px' }} />,
        }
      }
    >
      <Controller
        rules={rules}
        name={fieldname}
        control={control}
        defaultValue={initValue ?? ''}
        render={({ field: { onChange, value } }) => (
          <>
            {prefix && <div className="select_prefix">{prefix}</div>}
            <TimePicker
              value={value}
              className="formControl"
              // getPopupContainer={(trigger: any) => trigger.parentNode}
              onChange={(e, k) => {
                onChange(e)
                onTimeChange(e, k)
              }}
              minuteStep={5}
              {...iProps}
            />
            {hintMessage && <div className="hint-label">{hintMessage}</div>}
          </>
        )}
      />
    </Form.Item>
  )
}

export default TimeField
